import React, { useEffect, useRef } from "react";
import { Chart, registerables } from "chart.js";

// Register necessary components for the chart
Chart.register(...registerables);

const SpiderWebChart = ({ departmentScores }, chartRef) => {
  const canvasRef = useRef(null); // Canvas ref for rendering

  useEffect(() => {
    const ctx = canvasRef.current?.getContext("2d");

    if (chartRef.current) {
      chartRef.current.destroy(); // Destroy any existing chart instance
    }

    if (ctx && Object.keys(departmentScores).length > 0) {
      // Create a new Chart instance and assign it to chartRef
      chartRef.current = new Chart(ctx, {
        type: "radar",
        data: {
          labels: Object.keys(departmentScores),
          datasets: [
            {
              label: "Department Scores",
              data: Object.values(departmentScores),
              backgroundColor: "rgba(34, 202, 236, 0.2)",
              borderColor: "rgba(34, 202, 236, 1)",
              borderWidth: 2,
              pointBackgroundColor: "rgba(34, 202, 236, 1)",
            },
          ],
        },
        options: {
          scales: {
            r: {
              angleLines: { display: true },
              suggestedMin: 0,
              suggestedMax: 5,
            },
          },
          plugins: {
            legend: { display: true, position: "top" },
          },
        },
      });
    }

    // Cleanup to destroy the chart on component unmount or re-render
    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
      }
    };
  }, [departmentScores, chartRef]);

  return <canvas ref={canvasRef} width={400} height={400} />;
};

export default React.forwardRef(SpiderWebChart);
